<template>
  <v-container>
    <v-layout fill-height justify-center>
      <v-flex xs12 sm-8 md-6 lg-4 offset-sm-2 offset-md-3 offset-lg-4>
        <v-form v-model="valid" @submit.prevent="login()" v-if="!user" >
          <p class="headline display-3">Admin login</p>
          <v-text-field class="mt-1" :clearable="true" :autofocus="true" v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
          <v-text-field class="mt-1" :clearable="true" v-model="password" type="password" :rules="passwordRules" label="Wachtwoord" required></v-text-field>
          <v-btn class="mt-2 primary" :disabled="!valid" type="submit">Login</v-btn>
        </v-form>
        <div v-if="user">
          <p>U bent ingelogd als beheerder.</p>
          <v-btn :to="{name: 'logout'}" flat>Uitloggen</v-btn>
          <v-btn :to="{name: 'home'}" class="primary">Home</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="loggedIn"
      :bottom="true"
      :timeout="3000"
    >
      Ingelogd!
      <v-btn
        color="primary"
        flat
        @click="loggedIn = false"
      >
        Sluiten
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="logginError"
      :bottom="true"
      :timeout="3000"
    >
      Fout bij inloggen!
      <v-btn
        color="primary"
        flat
        @click="logginError = false"
      >
        Sluiten
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    email: process.env.NODE_ENV === 'production' ? "" : 'admin@sanavitasportmassage.nl',
    emailRules: [
      v => !!v || "E-mail is vereist",
      v => /.+@.+/.test(v) || "E-mail moet geldig zijn"
    ],
    password: process.env.NODE_ENV === 'production' ? "" : 'yve6mich',
    passwordRules: [
      v => !!v || "Wachtwoord is vereist"
    ],
    loggedIn: false,
    logginError: false
  }),
  computed : {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    login () {
      if (this.valid) {
        this.$store.dispatch('login', {
          email: this.email, 
          password: this.password
          }).then(success => {
          console.log(success)
          this.loggedIn = true
        }).catch(err => {
          console.log(err)
          this.logginError = true
        })
      }
    }
  }
};
</script>
